// mui components
import { Box, Stack } from "@mui/material";
// custom components
import CustomLayout from "../../components/layout";
// custom styles
import styles from "./index.module.scss";
import NewQuickPricer from "../../components/quick-pricer-form";

export default function QuickPricer() {
	const breadcrumbData = [
		{
			label: "Quick Pricer",
			path: "/quick-pricer",
		}
	];

	return (
		<Box>
			<CustomLayout breadcrumb={breadcrumbData} disabledOverflow={true}>
				<Stack
					direction="row"
					className={styles.stackContainer}
					sx={{
						overflow: "hidden",
					}}
				>
					<NewQuickPricer/>
				</Stack>
			</CustomLayout>
		</Box>
	);
}
